import * as React from 'react';
import ReactHtmlParser from '../../utils/SafeHtmlParser';
import SuperAgent from 'superagent';
import { Spin } from 'antd';

export interface HtmlTemplateViewProps {
  value: string;
  url?: boolean;
}

interface HtmlTemplateViewState {
  value: string;
  loading: boolean;
}

export default class HtmlTemplateView extends React.Component<
  HtmlTemplateViewProps,
  HtmlTemplateViewState
> {
  state: HtmlTemplateViewState = {
    value: '',
    loading: false,
  };

  fetchPage = () => {
    this.setState({ value: '', loading: true });
    SuperAgent.get(this.props.value).then((value: SuperAgent.Response) => {
      this.setState({ value: value.text, loading: false });
    });
  };

  componentDidMount(): void {
    if (this.props.url === true) {
      this.fetchPage();
    } else {
      this.setState({ value: this.props.value });
    }
  }

  componentDidUpdate(prevProps: Readonly<HtmlTemplateViewProps>): void {
    if (this.props.url !== prevProps.url || this.props.value !== prevProps.value) {
      if (this.props.url === true) {
        this.fetchPage();
      } else {
        this.setState({ value: this.props.value });
      }
    }
  }

  render(): React.ReactNode {
    return <Spin spinning={this.state.loading}>{ReactHtmlParser(this.state.value)}</Spin>;
  }
}
